import { render, staticRenderFns } from "./keyPostcon.vue?vue&type=template&id=542c444a&scoped=true&"
import script from "./keyPostcon.vue?vue&type=script&lang=js&"
export * from "./keyPostcon.vue?vue&type=script&lang=js&"
import style0 from "./keyPostcon.vue?vue&type=style&index=0&id=542c444a&scoped=true&lang=css&"
import style1 from "./keyPostcon.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542c444a",
  null
  
)

export default component.exports